




























import { Component, Vue } from "vue-property-decorator";
import {
  imageApiUrl,
  faceApiKey,
  faceApiEndpoint,
  speechApiKey,
} from "../settings";

@Component
export default class Navbar extends Vue {
  get showCameraButton(): boolean {
    return imageApiUrl !== "";
  }
  get showFaceButton(): boolean {
    return faceApiKey !== "" && faceApiEndpoint !== "";
  }
  get showSpeechButton(): boolean {
    return speechApiKey !== "";
  }
}
